import * as Yup from 'yup';
import { mapFieldType } from './mapFieldType';

export const generateValidationSchema = (formDetails) => {
  return Yup.object().shape(
    formDetails.reduce((acc, field) => {
      const fieldType = mapFieldType(field.fieldType);
      const isMultiSelect =
        fieldType === 'select' && field.typeSelection === 'multiple';

      let schema;

      if (fieldType === 'email') {
        schema = Yup.string().trim().email('Enter a valid email address');
      } else if (fieldType === 'phone') {
        schema = Yup.string().matches(
          /^\+?[1-9]\d{9,14}$/,
          'Enter a valid phone number'
        );
      } else if (fieldType === 'birthdate') {
        schema = Yup.date().nullable();
      } else if (fieldType === 'file') {
        schema = Yup.mixed().nullable();
      } else if (fieldType === 'checkbox' || isMultiSelect) {
        schema = Yup.array();
      } else {
        schema = Yup.string();
      }

      if (field.isMandatory) {
        if (fieldType === 'checkbox' || isMultiSelect) {
          schema = schema
            .min(1, `${field.fieldLabel} is required`)
            .required(`${field.fieldLabel} is required`);
        } else {
          schema = schema.required(`${field.fieldLabel} is required`);
        }
      }

      acc[field.fieldLabel] = schema;
      return acc;
    }, {})
  );
};
